import { render, staticRenderFns } from "./BetOddsSummaryMarketViewV3.vue?vue&type=template&id=5d94e90d&scoped=true"
import script from "./BetOddsSummaryMarketViewV3.vue?vue&type=script&lang=js"
export * from "./BetOddsSummaryMarketViewV3.vue?vue&type=script&lang=js"
import style0 from "./BetOddsSummaryMarketViewV3.vue?vue&type=style&index=0&id=5d94e90d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d94e90d",
  null
  
)

export default component.exports